import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of, switchMap, map, filter, take, catchError } from 'rxjs';
import { AuthService, UserProfile } from '../services/auth.service';
import { UserService, User } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class BillingAccessGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.authReady$.pipe(
      filter((ready) => ready === true),
      take(1),
      switchMap(() => this.authService.isAuthenticated$),
      take(1),
      switchMap((isAuth) => {
        if (!isAuth) {
          return of(this.router.parseUrl('/profile/details'));
        }

        return this.authService.userProfile$.pipe(
          filter((user): user is UserProfile => !!user),
          take(1),
          map((user) => {
            const isAdmin =
              user.role?.toLowerCase() === 'admin' ||
              user.role?.toLowerCase() === 'SuperAdmin' ||
              user.role?.toLowerCase() === 'SupportAdmin';
            const isB2B = user.subscriptionType?.toUpperCase() === 'B2B';

            if (isAdmin || isB2B) {
              return this.router.parseUrl('/profile/details');
            }

            return true;
          }),
        );
      }),
      catchError(() => of(this.router.parseUrl('/profile/details'))),
    );
  }
}
